var a = Object.defineProperty, f = Object.defineProperties;
var p = Object.getOwnPropertyDescriptors;
var i = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, d = Object.prototype.propertyIsEnumerable;
var t = (e, o, r) => o in e ? a(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, m = (e, o) => {
  for (var r in o || (o = {}))
    c.call(o, r) && t(e, r, o[r]);
  if (i)
    for (var r of i(o))
      d.call(o, r) && t(e, r, o[r]);
  return e;
}, n = (e, o) => f(e, p(o));
import s, { forwardRef as L } from "react";
import g from "../lib/IconBase.mjs";
import k from "../defs/LinkedinLogo.mjs";
const l = L((e, o) => /* @__PURE__ */ s.createElement(g, n(m({ ref: o }, e), { weights: k })));
l.displayName = "LinkedinLogo";
export {
  l as LinkedinLogo
};
